<div class="opening-hours-main">
  <div class="opening-hours-title">
    <h1>
      <span>{{ 'ADVERT.WORKING_HOURS' | translate }}</span>
    </h1>
  </div>
  <div class="opening-hours-selected-data">
    @if (anyScheduleExists()) {
      <div class="table-data-selected-table">
        @for (day of days; track day) {
          <div>
            <div class="selected-table-main">
              <div class="table-main-data">
                <h2>{{ day | uppercase | translate }}</h2>
              </div>
              <div class="table-main-data table-main-data-td">
                @if (isWorkingDay(day)) {
                  @if (isSlotAvailable(day)) {
                    <!-- TODO: the day is optional in interface. It needs to be fixed. Ensure track value -->
                    <!-- TODO: Simplify this logic, check if @for and @empty could be applied here -->
                    @for (data of getSlotData(day); track data) {
                      @if (data?.startHour && data?.endHour) {
                        <div class="timing">
                          <h2>{{ data?.startHour }}</h2>
                          <span>to</span>
                          <h2>{{ data?.endHour }}</h2>
                        </div>
                      }
                    }
                  } @else {
                    <h2 class="timing">{{ 'ADVERT.24_HOURS' | translate }}</h2>
                  }
                } @else {
                  <h2 class="timing">{{ 'ADVERT.CLOSED' | translate }}</h2>
                }
              </div>
            </div>
          </div>
        }
      </div>
    } @else {
      <p class="text-grey">
        {{ 'ADVERT.NO_SCHEDULE' | translate }}
      </p>
    }
  </div>
</div>
